var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("This is a Child page")]),_c('p',[_vm._v("count:"+_vm._s(_vm.count))]),_c('button',{on:{"click":_vm.add}},[_vm._v("add")])])}
var staticRenderFns = []

export { render, staticRenderFns }